export default "__VITE_ASSET__CzPZtEOx__"